// Path segments that are live credentials: the emailed password reset link,
// the no-login unsubscribe link, a shared chat's link and its revoke request
// (chat-shares/:token, never translated). Mirrors
// SentryPrivatePaths::BEARER_PATH on the server. Analytics page locations and
// error reports must never carry them.
const BEARER_PATH =
  /(\/(?:reset-password|unsubscribe|s|chat-shares)\/)[^/?#\s"]+/g;

export function redactBearerPaths(value) {
  return typeof value === 'string'
    ? value.replace(BEARER_PATH, '$1[redacted]')
    : value;
}

export function hasBearerPath(value) {
  return typeof value === 'string' && redactBearerPaths(value) !== value;
}
